
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sync/governance",
      function () {
        return require("private-next-pages/sync/governance.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sync/governance"])
      });
    }
  